import { TypographyOptions } from '@mui/material/styles/createTypography';

export const FONT_DISPLAY = '"Archivo", "Arial Narrow", sans-serif';
export const FONT_BODY = '"IBM Plex Sans", -apple-system, "Segoe UI", Roboto, sans-serif';
export const FONT_MONO = '"IBM Plex Mono", "SFMono-Regular", Consolas, monospace';

export const aquaRefineTypography: TypographyOptions = {
  fontFamily: FONT_BODY,
  h1: { fontFamily: FONT_DISPLAY, fontWeight: 700 },
  h2: { fontFamily: FONT_DISPLAY, fontWeight: 700 },
  h3: { fontFamily: FONT_DISPLAY, fontWeight: 700 },
  h4: { fontFamily: FONT_DISPLAY, fontWeight: 700 },
  h5: { fontFamily: FONT_DISPLAY, fontWeight: 700 },
  h6: { fontFamily: FONT_DISPLAY, fontWeight: 700 },
  subtitle1: { fontWeight: 700 },
  button: { textTransform: 'none', fontWeight: 600 },
};
